/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    taskList: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '12px'
    }
});
